import { clickListener } from "./clickListener";
import { showOverlay } from "../Overlay/showOverlay";

export const overlayOpenListener = () => {
    // @ts-ignore
    const ctaButton = window.cta as HTMLElement;
    ctaButton.setAttribute('open-overlay', '');
	clickListener('open-overlay', showOverlay);
    
}